import { render, staticRenderFns } from "./odometerReport.vue?vue&type=template&id=10b56cfc&scoped=true&"
import script from "./odometerReport.vue?vue&type=script&lang=js&"
export * from "./odometerReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b56cfc",
  null
  
)

export default component.exports